module.exports = __webpack_public_path__ + "img/guoHui.d0289dc0.png";